import {Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip} from "react-bootstrap";
import React, {useEffect, useState} from 'react';
import {useContext} from "react";
import {store} from "../../Store/store";
import { PAIRING} from "./Types";


export default function PairVmaBySerialNumberModal({
                                                       isPollingInProgress,
                                                       setIsPollingInProgress,
                                                       setIsPairClicked,
                                                       setSelectedVmaRow,
                                                       selectedVmaRow,
                                                       vmaData,
                                                       setVmaData,
                                                       setPairingVmaUuid,
                                                       controlUnitService,
                                                       controlUnitId,
                                                       setShow,
                                                       show
                                                   }) {
    const stateObj = useContext(store);
    const [isSavingInProgress, setIsSavingInProgress] = useState(false);
    const [serialNumber, setSerialNumber] = useState('');

    const getCurrentVmaState = () => {
        const currentVma = stateObj.state.vmaListArr.filter((obj) => obj.uuid === selectedVmaRow.uuid)
        return currentVma[0];
    }

    const handlePair = () => {
        getCurrentVmaState();
        setIsPollingInProgress(true);
        setIsPairClicked(true);
        setSelectedVmaRow({...selectedVmaRow, pairingState: PAIRING});
        const newVmaData = vmaData.map((obj) => {
            if (obj.uuid === selectedVmaRow.uuid) {
                return {...obj, pairingState: PAIRING};
            } else {
                return obj
            }
        })
        setVmaData(newVmaData);
        setPairingVmaUuid(selectedVmaRow.uuid);
        controlUnitService.pairVmaBySerialNumber(controlUnitId, selectedVmaRow.uuid, serialNumber);
        setShow(false);
    }

    const handleCancel = () => {
        setShow(false);
    }

    useEffect(() => {
        vmaData?.forEach(vma => {
            if (vma.uuid === selectedVmaRow?.uuid) {
                setSelectedVmaRow(vma);
            }
        })

    }, [vmaData])

    return (
        <Modal dialogClassName="filter-modal" show={show} onHide={() => {
            if (!isSavingInProgress) {
                setShow(false);
            }
        }} style={{marginTop: '10%', left: '-10%', width: '2300px'}}>
            <Modal.Header closeButton>
                <Modal.Title>Pair VMA By Serial Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Row>
                        <Form.Group as={Col} md={8} controlId="formGridId1">
                            <Form.Label>Serial Number:</Form.Label>
                            <Form.Control value={serialNumber} onChange={e => setSerialNumber(e.target.value)}/>
                        </Form.Group>
                    </Form.Row>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <div className='d-inline-block mr-2'>
                                    <Button disabled={isPollingInProgress} style={{width: 80}} onClick={() => handlePair()} variant="primary">Pair</Button>
                        </div>
                        <div className='d-inline-block'>
                            <Button disabled={isSavingInProgress} style={{width: 80}} onClick={() => handleCancel()} variant="primary">Cancel</Button>
                        </div>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
}
